<template>
  <div
    :test-id="`stat-${stat.label}`"
    :class="`collector-stat-item ${stat.itemClass}`"
  >
    <span class="collector-stat-label">{{stat.label}}:</span>
    <span class="collector-stat">{{stat.value}}</span>
  </div>
</template>

<script>
export default {
  name: 'Stat',
  props: {
    stat: Object
  }
};
</script>

<style scoped lang="scss">

@import '../../assets/sass/config';

.collector-stat-item {
  font-size: 18px;
  display: block;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center;
  padding: 10px 20px;
  width: (100% / 6);

  @media (max-width: 768px) {
    width: (100% / 2);
  }

  @media (max-width: 568px) {
    width: 100%;
  }

  &::before {
    height: 60px;
    width: 60px;
    border-radius: 30px;
    display: block;
    margin: auto;
    background-color: $accent-color;
    line-height: 60px;
    color: #fff;
    margin-bottom: 20px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 24px;
  }
}

.stat-total-collected::before,
.stat-herd-collected::before {
  content: $plus-icon;
}

.stat-herd-value::before {
  content: $dollars-icon;
}

.stat-most-collected::before {
  content: $check-box-icon;
}

.stat-priciest::before {
  content: $money-icon;
}

.stat-most-wanted::before {
  content: $gift-icon;
}

.stat-most-loved::before {
  content: $heart-icon;
}

.collector-stat-label {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 900;
  display: block;
  color: $dark-blue;
  font-family: Roboto, sans-serif;
}

.collector-stat {
  font-size: 24px;
  padding-bottom: 20px;
  font-weight: 900;
  color: $accent-color;
  font-family: Roboto, sans-serif;

  @media (max-width: 1000) {
    font-size: 20px;
  }
}

</style>
